import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
 
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Phenophase } from './phenophase';
import { Species } from './species';
import { ScistarterRecordEventResponse } from './scistarterResponse';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {
    this.baseUrl = 'https://services.usanpn.org/one-time-obs-services/v0/';
  }

  baseUrl: string;

  getPhenophases(): Observable<Phenophase[]> {
    return this.http.get(this.baseUrl+"phenophases?phenophase_id=1,2,3").pipe(map(res => <Phenophase[]>res));
  }

  getSpecies(): Observable<Species[]> {
    return this.http.get(this.baseUrl+"species?species_id='1'").pipe(map(res => <Species[]>res));
  }

  submitSciStarterCollection(email: string): Observable<ScistarterRecordEventResponse> {
    return this.http.get(`${this.baseUrl}observations/submitSciStarterCollection/${email}`).pipe(map(res => <ScistarterRecordEventResponse>res));
  }
}
